import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Button, LinearProgress } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { TEST, VIDEO } from '../../../../utils/constants'
import {
    CourseState,
    SectionDetailsState,
    SectionState,
    SubjectState,
    UserTopicState,
} from '../../../../features/types'
import VideoContent from './VideoContent'
import QuizContent from './QuizContent'

interface Props {
    subject: SubjectState
    course: CourseState
    isFetchingSectionDetails: boolean
    isFetchingSections: boolean
    sectionDetails: SectionDetailsState
    selectedSection: SectionState
    selectedTopic: UserTopicState
    selectedTopicSections: SectionState[]
    currentSectionIndex: number
    userSubjectEnrollId: number
    onPreviousSection: () => void
    onNextSection: () => void
}

const styles = {
    content: {
        width: '100%',
        borderRadius: '8px',
    },
    buttons: {
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'space-between',
        mt: 4,

        '@media screen and (max-width: 500px)': {
            display: 'none',
        },
    },
}

const TopicContent: React.FC<Props> = ({
    course,
    subject,
    isFetchingSectionDetails,
    isFetchingSections,
    sectionDetails,
    selectedSection,
    selectedTopic,
    selectedTopicSections,
    currentSectionIndex,
    userSubjectEnrollId,
    onPreviousSection,
    onNextSection,
}) => {
    const { formatMessage } = useIntl()

    return (
        <Box sx={styles.content}>
            {(isFetchingSectionDetails || isFetchingSections) && (
                <LinearProgress />
            )}

            {sectionDetails && (
                <Box>
                    {selectedSection.type === VIDEO && (
                        <VideoContent
                            key={selectedSection.id}
                            videoDetails={sectionDetails}
                            videoLessonId={selectedSection.id}
                            userTopicEnrollId={selectedTopic.userTopicEnrollId}
                            userSubjectEnrollId={+userSubjectEnrollId}
                        />
                    )}

                    {selectedSection.type === TEST && (
                        <QuizContent
                            topic={selectedTopic}
                            section={selectedSection}
                            sectionDetails={sectionDetails}
                            course={course}
                            subject={subject}
                        />
                    )}

                    <Box sx={styles.buttons}>
                        <Button
                            variant="outlined"
                            startIcon={<ChevronLeft />}
                            onClick={() => onPreviousSection()}
                            disabled={currentSectionIndex === 0}
                        >
                            {formatMessage({ id: 'back' })}
                        </Button>

                        <Button
                            variant="contained"
                            endIcon={<ChevronRight />}
                            onClick={() => onNextSection()}
                            disabled={
                                currentSectionIndex ===
                                selectedTopicSections.length - 1
                            }
                        >
                            {formatMessage({ id: 'next' })}
                        </Button>
                    </Box>
                </Box>
            )}
        </Box>
    )
}

export default TopicContent
